import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImages5"><Path d="M12.5 7C12.5 8.65685 11.1569 10 9.5 10C7.84315 10 6.5 8.65685 6.5 7C6.5 5.34315 7.84315 4 9.5 4C11.1569 4 12.5 5.34315 12.5 7Z" stroke="currentColor" strokeLinecap="round"/><Path d="M5.93814 12.7206C3.52211 12.7206 2 19.2496 2 19.2496H22C20.2005 13.0019 18.2925 9.6091 16.5 9.75761C13.5232 10.0042 12.2165 14.6685 10.5 14.6685C9.0731 14.6685 7.74143 12.7206 5.93814 12.7206Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconImages5;
